<template>
  <b-dropdown :mobile-modal="false" position="is-bottom-left"  style="margin-left:5px;" aria-role="list">
    <button class="button-dropdown-section" slot="trigger">
      <template>
        <div
          v-if="sections[indexSection].questions[indexQuestion].answers[indexProposition].next_section===0"
        >
          <div v-for="section in sections_dropdownSectionListAnswer_copy" :key="section.id">
            <div
              v-if="section.conditional_section===sections[indexSection].questions[indexQuestion].answers[indexProposition].conditional_section"
            >
              <p>{{section.entitled.length>30 ? section.entitled.substr(1,30)+('...') : section.entitled}}</p>
            </div>
          </div>
        </div>
        <div v-else>{{$t('sections.move_on_next')}}</div>
      </template>
    </button>
    <div v-for="(section,index) in sections_dropdownSectionListAnswer_copy" :key="section.id">
      <b-dropdown-item @click="sectionSelected(index, section)">
        <p>{{section.entitled}}</p>
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      sections_dropdownSectionListAnswer_copy: []
    }
  },
  props: {
    indexQuestion: {
      type: Number,
      required: true
    },
    indexSection: {
      type: Number,
      required: true
    },
    indexProposition: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(['sections'])
  },
  watch: {
    sections () {
      this.sections_dropdownSectionListAnswer_copy = []
      this.function_sections_dropdownSectionListAnswer_copy()
    }
  },
  created () {
    this.function_sections_dropdownSectionListAnswer_copy()
  },
  methods: {
    function_sections_dropdownSectionListAnswer_copy () {
      // toutes les autres sections
      this.sections.map((section, index) => {
        if (this.sections[this.indexSection].order < section.order) {
          this.sections_dropdownSectionListAnswer_copy.push({
            entitled: section.entitled,
            conditional_section: section.id
          })
        }
      })
      // "passer à la section suivante => sortie: null, unshift au début du tableau"
      this.sections_dropdownSectionListAnswer_copy.unshift({
        entitled: this.$i18n.t('sections.move_on_next'),
        conditional_section: null
      })
      // Envoyer le formulaire => sortie: -1, index: toujours à la fin
      this.sections_dropdownSectionListAnswer_copy.push({
        entitled: this.$i18n.t('sections.send_form'),
        conditional_section: -1
      })
    },
    sectionSelected (index, section) {
      this.$store.commit('UDPATE_SECTIONS_OPTIONS', {
        type: 'update_answers_conditional_section_next_section',
        indexSection: this.indexSection,
        indexQuestion: this.indexQuestion,
        indexAnswer: this.indexProposition,
        conditional_section: section.conditional_section
      })
    }
  }
}
</script>

<style scoped>
.button-dropdown-section{
    white-space: nowrap;
    text-align: center;
    padding: 4px;
    font-size:12px;
    background-color:#e1e1e1;
    border:#cccccc 1px solid;
    color:black;
  }
  .button-dropdown-section:hover{
    white-space: nowrap;
    text-align: center;
    padding: 4px;
    font-size:12px;
    background-color:#e1f3ff;
    border:#76beee 1px solid;
    color:black;
  }
</style>



// WEBPACK FOOTER //
// src/components/question/section/dropdown/DropdownSectionListAnswer.vue